/**
 * Script for All Pages
 *
 * @author Space-Time Inc.
 * @version 2024-02-13
 */

/**
 * Minimum Viewport (JS)
 *
 * @author Space-Time Inc.
 * @version 2022-10-18
 */

(() => {
	const MIN_WIDTH = 360;

	const vp = document.querySelector('meta[name="viewport"]');
	function fn() {
		const v = window.outerWidth > MIN_WIDTH ? 'width=device-width,initial-scale=1' : `width=${MIN_WIDTH}`;
		if (vp.getAttribute('content') !== v) {
			vp.setAttribute('content', v);
		}
	}
	addEventListener('resize', throttle(fn), false);
	fn();

	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	
})();

/**
 * Scroll To Top
 *
 * @author Space-Time Inc.
 * @version 2024-02-09
 */

(() => {
	function init() {
		const btn = document.getElementById('scroll-to-top');
		if (btn === null) return;
		const ph  = btn.parentElement;

		const offset = parseInt(btn.dataset['offset'] ?? '0');
		const align  = btn.dataset['align'] ?? 'bottom';

		let fact = 0;
		switch (align) {
			case 'top'   : fact = 0;   break;
			case 'middle': fact = 0.5; break;
			case 'bottom': fact = 1;   break;
		}

		onScroll(scrollHandler);
		onResize(scrollHandler);
		if ('ontouchstart' in window) window.addEventListener('touchmove', scrollHandler);
		setTimeout(scrollHandler, 100);

		btn.addEventListener('click', () => {
			window.scroll({ top: 0, behavior: 'smooth' });
		});

		function scrollHandler() {
			const btnR = btn.getBoundingClientRect();
			const btnH = (btnR.bottom - btnR.top) * fact;

			const viewBottomY = window.innerHeight - offset - btnH;
			const footerTopY = ph.getBoundingClientRect().top;

			if (viewBottomY > footerTopY) {
				btn.style.transform = 'translateY(-' + (viewBottomY - footerTopY + offset) + 'px)';
				btn.classList.remove('fixed');
			} else {
				btn.style.transform = `translateY(-${offset}px)`;
				btn.classList.add('fixed');
			}

			if (window.scrollY > window.innerHeight / 3) {
				btn.classList.remove('hidden');
			} else {
				btn.classList.add('hidden');
			}
		}
	}


	// -------------------------------------------------------------------------


	/**
	 * Throttling Function
	 *
	 * @author Space-Time Inc.
	 * @version 2022-10-13
	 */
	
	function throttle(fn) {
		let isRunning;
		return (...args) => {
			if (isRunning) return;
			isRunning = true;
			requestAnimationFrame(() => {
				isRunning = false;
				fn(...args);
			});
		};
	}
	

	const resizeListeners = [];
	const scrollListeners = [];

	function onResize(fn, doFirst = false) {
		if (doFirst) fn();
		resizeListeners.push(throttle(fn));
	}

	function onScroll(fn, doFirst = false) {
		if (doFirst) fn();
		scrollListeners.push(throttle(fn));
	}

	document.addEventListener('DOMContentLoaded', () => {
		window.addEventListener('resize', () => {
			for (const l of resizeListeners) l();
		}, { passive: true });
		window.addEventListener('scroll', () => {
			for (const l of scrollListeners) l();
		}, { passive: true });
	});

	init();
})();

/**
 * Search Popup (JS)
 *
 * @author Space-Time Inc.
 * @version 2024-02-13
 */

document.addEventListener('DOMContentLoaded', () => {
	const btn = document.querySelector('#btn-search-popup');
	if (!btn) return;

	const popup = document.querySelector('#search-popup');
	if (!popup) return;

	btn.addEventListener('click', () => {
		btn.classList.toggle('open');
		popup.classList.toggle('open');
	});
});

/**
 * Toggle Button
 *
 * @author Space-Time Inc.
 * @version 2023-02-21
 */

 document.addEventListener('DOMContentLoaded', () => {

	const btns = document.querySelectorAll('.user-content *[class^="button"]');

	for (let i = 0; i < btns.length; i += 1) {
		if (isToggleButton(btns[i])) setEventListener(btns[i]);
	}

	function isToggleButton(btn) {
		if (!btn.href || btn.href[btn.href.length - 1] !== '#') return false;
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		return f.classList.contains('frame') || f.classList.contains('frame-alt');
	}

	function setEventListener(btn) {
		btn.classList.add('toggle');
		initFrame(btn);
		btn.addEventListener('click', (e) => {
			if (btn.classList.contains('active')) {
				btn.classList.remove('active');
				setFrameVisible(btn, false);
			} else {
				btn.classList.add('active');
				setFrameVisible(btn, true);
			}
			e.preventDefault();
		});
	}

	function initFrame(btn) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		f.style.display = 'none';
		f.classList.add('hidden');
		setTimeout(() => { f.style.display = ''; }, 10);
	}

	function setFrameVisible(btn, visible) {
		const p = btn.parentElement;
		const f = p.nextElementSibling;
		if (visible) {
			f.classList.remove('hidden');
		} else {
			f.classList.add('hidden');
		}
	}

});


document.addEventListener('DOMContentLoaded', () => {
	/**
	 * Dynamic Filter - Lists by Terms
	 *
	 * @author Space-Time Inc.
	 * @version 2024-09-12
	 */
	
	(() => {
		class DynamicFilter {
			#maxCount;
	
			#bs;
			#its;
			#as;
			#yearSel;
	
			constructor(flt, list, arch) {
				this.#maxCount = parseInt(list.dataset?.maxCount ?? '6');
	
				this.#bs  = flt.querySelectorAll('button');
				this.#its = list.querySelectorAll(':scope > li');
				this.#as  = arch ? arch.querySelectorAll('a') : [];
	
				this.#hideEmpty(list);
				for (const b of this.#bs) b.addEventListener('click', e => this.#onClick(e));
	
				this.#yearSel = flt.querySelector('select.year');
				this.#yearSel.addEventListener('change', e => this.#onSelectYear(e));
				this.#initYearSelect(this.#yearSel, this.#its);
	
				if (location.hash) {
					const n = '-' + location.hash.slice(1);
					for (const b of this.#bs) {
						if (b.dataset.type.endsWith(n)) {
							b.click();
							break;
						}
					}
				} else {
					this.#bs[0].click();
				}
			}
	
			#hideEmpty(list) {
				for (const b of this.#bs) {
					const t = b.dataset.type;
					if ('all' === t) continue;
	
					const it = list.querySelector(`:scope > li.${t}`);
					if (!it) {
						b.classList.add('empty');
						const p = b.parentElement;
						if ('LI' === p.tagName) p.classList.add('empty');
					}
				}
			}
	
			#onClick(e) {
				const cur = e.currentTarget;
				for (const b of this.#bs) {
					const p = b.parentElement;
					if (cur === b) {
						b.classList.add('current');
						if ('LI' === p.tagName) p.classList.add('current');
					} else {
						b.classList.remove('current');
						if ('LI' === p.tagName) p.classList.remove('current');
					}
				}
				const t = cur.dataset.type;
				for (const a of this.#as) {
					a.style.display = (t === a.dataset.type) ? '' : 'none';
				}
				this.#filterItems(t, null, this.#maxCount);
			}
	
			#initYearSelect(yearSel, its) {
				const cs = [];
				for (const it of its) {
					it.classList.forEach(cn => {
						if (/^y\d+$/.test(cn)) {
							cs.push(cn);
						}
					})
				}
				cs.sort((a, b) => {
					const numA = parseInt(a.slice(1), 10);
					const numB = parseInt(b.slice(1), 10);
					return numA - numB;
				});
				for (const c of [...new Set(cs)]) {
					const o = document.createElement('option');
	
					o.innerText = parseInt(c.slice(1), 10);
					o.value     = c;
	
					yearSel.appendChild(o);
				}
			}
	
			#onSelectYear(e) {
				const cur = e.currentTarget;
				const y   = cur.value;
				this.#filterItems(null, y, this.#maxCount);
			}
	
			#curType = null;
			#curYear = null;
	
			#filterItems(t, y, count) {
				if (t !== null) this.#curType = t; else t = this.#curType;
				if (y !== null) this.#curYear = y; else y = this.#curYear;
	
				for (const it of this.#its) {
					if (count) {
						const v =
							(t === null || 'all' === t || it.classList.contains(t)) &&
							(y === null || 'all' === y || it.classList.contains(y));
						if (v) {
							it.style.display = '';
							count -= 1;
						} else {
							it.style.display = 'none';
						}
					} else {
						it.style.display = 'none';
					}
				}
			}
		}
	
		const fs = document.querySelectorAll('.part-dynamic-filter');
		if (1 === fs.length) {
			let l = document.querySelector('.part-dynamic-filter + .list-item');
			let a = document.querySelector('.part-dynamic-archive');
	
			if (!l) {
				const id = fs[0].dataset?.filterId ?? '';
				if (id) {
					l = document.querySelector(`.list-item[data-filter-id='${id}']`);
					if (!a) a = document.querySelector(`.part-dynamic-archive[data-filter-id='${id}']`);
				}
			}
			if (l) new DynamicFilter(fs[0], l, a);
		} else {
			for (const f of fs) {
				const id = f.dataset?.filterId ?? '';
				if (id) {
					const l = document.querySelector(`.list-item[data-filter-id='${id}']`);
					const a = document.querySelector(`.part-dynamic-archive[data-filter-id='${id}']`);
					if (l) new DynamicFilter(f, l, a);
				}
			}
		}
	})();
	
});
